package ru.it_mozaika.sender.js.application.frames.segments

import io.ktor.client.call.*
import js.core.ReadonlyRecord
import js.core.jso
import mui.icons.material.DeleteForeverSharp
import mui.material.*
import mui.material.styles.Theme
import mui.material.styles.useTheme
import mui.system.responsive
import mui.system.sx
import oldcomponents.NotyType
import oldcomponents.showNotification
import react.*
import ru.it_mozaika.components.*
import ru.it_mozaika.sender.common.models.*
import ru.it_mozaika.sender.js.application.Http
import ru.it_mozaika.utils.checkResponseError
import ru.it_mozaika.sender.js.application.components.segments.segmentDeleteDialog
import ru.it_mozaika.sender.js.application.components.segments.segmentDialog
import ru.it_mozaika.components.commonTableSkeletonFrame
import ru.it_mozaika.sender.js.application.frames.MainCard
import tanstack.react.table.useReactTable
import tanstack.table.core.*
import web.cssom.*


val segmentsListFrame =  VFC{
    val (segments, setSegments) = useState(listOf<NamedItem>())
    val tableColumns = listOf("ID", "Наименование")
    val (size, setSize) = useState(0)
    val (selectedProperty, setSelectedProperty) = useState("")
    val (rowsPerPage, setRowsPerPage) = useState(10)
    val (page, setPage) = useState(0)
    val (checkedProperties, setCheckedProperties) = useState(listOf<String>())
    val (showFilter, setShowFilter) = useState(false)
    var (columnVisibility, setColumnVisibility) = useState<ReadonlyRecord<String, Boolean>>(jso {})
    val (columnOrder, setColumnOrder) = useState<ColumnOrderState>(jso {})
    val (propertiesDict, setPropertiesDict) = useState<ColumnsFilter>()
    val (searchQuery, setSearchQuery) = useState("")
    val (propertiesFilter, setPropertiesFilter) = useState<List<ColumnsFilter>>(listOf())
    val (selectedSegment, setSelectedSegment) = useState<List<NamedItem>>(listOf())
    val (showSegmentsDialog, setShowSegmentDialog) = useState(false)
    val (selectedSegmentId, setSelectedSegmentId) = useState<String>()
    val (showDeleteDialog, setShowDeleteDialog) = useState(false)


    fun getData(){
        Http.get("/segments") { response ->
            response.checkResponseError()?.let {
                showNotification(it, NotyType.Error)
                return@get
            }
            val list = response.body<List<NamedItem>>()
            setSegments(list)
            setSize(list.size)
        }
    }
    useEffect(rowsPerPage, page, searchQuery){
        getData()
    }
    val table = useReactTable<NamedItem>(
        options = jso {
            columns = useMemo(tableColumns) {
                tableColumns.map { column ->
                    jso<ColumnDef<NamedItem, Any?>> {
                        accessorFn = {item, _ ->
                            when (column) {
                                "ID" -> item.id
                                "Наименование" -> item.name
                                else -> ""
                            }
                        }
                        cell = ColumnDefTemplate { context ->
                            val value = context.getValue().toString()
                            val segmentId = context.row.getValue("ID").toString()
                            val columnId = context.column.id
                                Box.create {
                                    +value
                                }
                        }
                        id = column
                        header = StringOrTemplateHeader(column)
                    }
                }
            }.toTypedArray()
            this.data = useMemo(segments) { segments.toTypedArray() }
            this.state = jso {
                this.columnVisibility = columnVisibility
                this.columnOrder = columnOrder
            }
            this.onColumnVisibilityChange = {
                columnVisibility = it.unsafeCast<ReadonlyRecord<String, Boolean>>()
                setColumnVisibility(it.unsafeCast<ReadonlyRecord<String, Boolean>>())
            }
            this.onColumnOrderChange = {
                setColumnOrder(it.unsafeCast<Array<String>>())
            }
            this.getCoreRowModel = getCoreRowModel()
            this.debugTable = true
            this.debugHeaders = true
            this.debugColumns = true
        }
    )
    segmentDialog{
        this.isOpen = showSegmentsDialog
        this.onClose = {
            setShowSegmentDialog(false)
            setSelectedSegmentId(null)
            getData()
        }
        this.id = selectedSegmentId
    }
    segmentDeleteDialog{
        isOpen = showDeleteDialog
        this.selected = selectedSegment
        this.onClose = {
            setSelectedSegment(listOf())
            setShowDeleteDialog(false)
            getData()
        }
    }
    MainCard {
        title = "Сегменты"
        actions = Stack.create {
            this.direction = responsive(StackDirection.row)
            this.divider = Divider.create {
                orientation = Orientation.vertical
            }
            asDynamic().spacing = 2
            sx {
                this.width = 100.pct
                border = 2.px
                this.alignItems = AlignItems.center
                this.justifyContent = JustifyContent.flexStart
            }
            AvatarButton {
                onClick = {
                    setSelectedSegmentId(null)
                    setShowSegmentDialog(true)
                }
                tooltipTitle = "Добавить новый сегмент"
                mui.icons.material.AddCircleOutlineSharp()
            }
        }
        commonTableSkeletonFrame {
            showCheckBox = true
            currentSelected = selectedSegment.map{it.id}
            toolbarActions =  Stack.create {
                this.direction = responsive(StackDirection.row)
                asDynamic().spacing = 2
                sx {
                    this.width = 100.pct
                    border = 2.px
                    this.alignItems = AlignItems.center
                    this.justifyContent = JustifyContent.flexStart
                }
                if (checkedProperties.isNotEmpty()) {
                    filterOffButton {
                        this.propertiesFilter = checkedProperties
                        this.handleOnFilterOffClick = {
                            setCheckedProperties(listOf())
                            setPropertiesFilter(listOf())
                            setSearchQuery("")
                        }
                    }
                }
                if(selectedSegment.isNotEmpty()){
                    AvatarButton {
                        onClick = {
                            setShowDeleteDialog(true)
                        }
                        tooltipTitle = "Удалить сегменты"
                        palettecolor = useTheme<Theme>().palette.error
                        DeleteForeverSharp()
                    }
                }
            }
            this.label = "segments-list"
            this.propertiesFilter = propertiesFilter
            this.columnId = "ID"
            this.table = table
            this.onPropertySelect = { property ->
                setSelectedProperty(property)
                if (showFilter) setShowFilter(false) else setShowFilter(true)
            }
            this.onSelectionChanged = { newSelected ->
                val selected = newSelected.mapNotNull{id ->
                    segments.find{it.id == id}
                }
                setSelectedSegment(selected)
            }
            onDoubleClickHandler = {
                setSelectedSegmentId(it)
                setShowSegmentDialog(true)
            }
        }
        TablePagination {
            this.page = page
            this.count = size
            this.onPageChange= { _, newPage ->
                setPage(newPage.toInt())
            }
            this.onRowsPerPageChange = { event ->
                setRowsPerPage(event.target.asDynamic().value as Int)
                setPage(0)
            }
            this.rowsPerPage = rowsPerPage
        }
    }
}